var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBomberos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: -5,
    width: 38,
    height: 38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9523.72,
    y: -0.0471044,
    width: 380952,
    height: 371429
  })), /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAYISURBVFhH5ZlZTJVHFMdRQWXVG6wg4gUuCLLIIgoNQa6G5TbFRBEqVQHTSEhEqTwYU4tLNTygNVqjdYmJJqQhammNoklBi9GYEIUSYlyKidFYxIiJca8WZ07nzByWexG+AcE+9JfMg8ycM/87yzlnPp3+N/CamiienZ3EzeYkbjIl8YyMJF5ZmUTd/w28oiIcYmO/YdOm/SYah1GjAJyc+jRmMnHm53cVwsMr+KZNNjIfWXhJSQ6LiGiAsWN7xPj6AsydC1BQALBmDcDatQArVwLYbAAWC8Do0Wqc+CHM37+V5+au45cve5LL4YNv3TqHRUY2dK9YZCRAeTnAzZsAnEO/YN/DhwCHDwNYrQBjxqgVDgrq4AUFWeT+w+Hp6V8zLy8uxcXHA5w5M7Cwgbh2DWDxYrW6orHExEpxdt1pqsHDW1rcWXz8Ubl67u4Ae/YAMEazfSDnzwMEBKhVnTz5Mq+unk7T6gNNTW7iV16Sq4fn6vp18j6MPH0KkJGhhAYGPuT79oXQ9HrIFUSBcXEAHR3kdQTo7ARYsUIJtVhu8pwcV5IwMDw1tURucXDwyArsAo/QokVKaFTULySjf/i2bTHM07NTnkE85B+LFy9AxFIZpkRSWE1y3g8LCfldbvPevWT9EWluBnB2BhFJ2nlVlQ9JskcE4kUyNGCY0bnFt24BzJwJ4O9v3/DW4t+zswF27QK4d48MNCgtVdtutf5AsuxhcXHNchUxDupw8KB0aNjGjwc4dIiMDHj0CMDNDZiPz1ve3PwJSVPw7dunS2eYSXQD9f79fcV4eKiY2pUKuxr++8IFMjSguFjacJutkOQpeELCt9JZRQWN1MBR5KlTAC9fAjx/rtLlggX2/bj9OjQ0yPEsOLiO5ClYaKgK3OhcF0eRtbXUQWCwdnHp6Y+IoA4DcCexaJk6FeDEiTEkUXjAw44dg8nJjiLr6qijF+izqx8vky65ucqmrGyeFMhra4Nk8E5LoxGaGIlsbZVxr7t/9Wrq0AArLGHD58//SoqE5cvnSSdFRTRCE0eRR44A3LmjxGGEiIrq6ZsyBaCtjQw1qKqSdjw6eosSGRamRK5fTyM0cRTZX8OIcfcuGWly9qyy9fb+TomcMEGJ3LiRRmiiKxIbruqVK2Sowblzym7cOBJptSqRGO0Hg6PI5GSAnByAJUtUCebtbd+P8fP2bTI24ORJacMDA2m7d+9WIvFGDQaji/P6tarCe4/Jy6NOAw4cUONtNrWSiPyVsbE0QhNHkY5xEsFSr3f28fOjDgMoh0NMjApBiKiM/8IKRGYLXXREIp6ePWO8vOiPBiQmAr5I+fHjPdW6KC5+kk5On6ZRGuiIxPKr9xi8QEY8eaJKNouljeQpID//C+lk6VIaqYGjyGPHVBWDW9zermJlSIj9GJ0IQtUVmzPnR5KnEF2jxZa/BldX9U7WwVEkvqnxyGCj97VdQ8FGxwnT8qxZ0p6Xl39K8npgaWm7pLN168jCAN16ElNjejrAgwdkOAC4+sKGxcT8QbLsERWHL5s06W8RQPXi2Y0bePsAgoL6trAwgJQUdUuvXtWr9N+8Ue8csRO8uHghyeoLT04ukb8eJ8Dn5sdkwwa1iqGh1STn/UBTkwsLCFC15WBz+YdQU6M+u3h5PYItW8wkp3/EoEDm4dEmzxJejpGmsVE+O5iLy1uemfk5yTCGl5VlsIkT/5HZYseO4fsG5Ah+E8IAL24zy8vbStPrw0tLF8qLhFuPOffZM/I8DLx7B7Bzp3xeiBXsZPn539O0g4enpoYys/mBFGo2q4yEEwwVjIMtLeqjq/DJTKa3PCVlMU03dETF7saSk88yZ2cmxc6ejQ8kgFevaGYNMFJcugSQlaWCvTjvbMaMG8L3DJpmeOBFRZ+x6Og/u6sak0mVYni5Ll4EuH9fHQl81mLWwgtRWQlQWNj9LVKKM5s7+LJl68ntyMBXrcoQYn9mPj7v7B5aAzTm7s5EFmnkVuuX/PHj4f9ePhDyv0USEjaz+Phfmb9/PXN1rRcXoZ75+tazxMR6brFsFuc6UxyPCWQyBJyc/gWRNSidJgnnBgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.234375 0.00146775 361905 0.00146775 361905 361905 0.25 361905Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-944 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000105 0 0 0.000105 944 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "matrix(8826.95 0 0 8826.95 0.234375 0.00146775)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomberos);
export default __webpack_public_path__ + "static/media/Bomberos.52459d3a3170ce0f7dd03bdfbd03fa30.svg";
export { ForwardRef as ReactComponent };